var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.244141,
    y: 0.0792236,
    width: 160,
    height: 160,
    rx: 2,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2441,
    cy: 52.0792,
    r: 28,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.244 160.079C159.349 160.079 160.248 159.183 160.207 158.08C159.914 150.094 157.865 142.213 154.155 134.822C150.134 126.815 144.241 119.539 136.813 113.41C129.384 107.282 120.565 102.42 110.859 99.1032C101.153 95.7864 90.7499 94.0792 80.2441 94.0792C69.7384 94.0792 59.3355 95.7864 49.6295 99.1032C39.9234 102.42 31.1043 107.282 23.6756 113.41C16.2469 119.539 10.3542 126.815 6.33378 134.822C2.62285 142.213 0.574237 150.094 0.280863 158.08C0.24031 159.183 1.13957 160.079 2.24414 160.079L80.2441 160.079H158.244Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileimg);
export default __webpack_public_path__ + "static/media/profileimg.d4e9720d63e1aa3b1598ca35e319c495.svg";
export { ForwardRef as ReactComponent };